function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useState, useEffect } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Statistic, Image, message } from 'antd';
import CashierTransactionsList from "./CashierTransactionsList";
import Common from "./includes/Common";
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from "react-moment";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CashierReport = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var customer = _ref.customer;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    postPaidAmount = _useState2[0],
    setPostPaidAmount = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    totalCash = _useState4[0],
    setTotalCash = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    totalAmount = _useState6[0],
    setTotalAmount = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    customers = _useState8[0],
    setCustomers = _useState8[1];
  var _useState9 = useState(moment().startOf('day').format()),
    _useState0 = _slicedToArray(_useState9, 2),
    from = _useState0[0],
    setFrom = _useState0[1];
  var _useState1 = useState(moment().endOf('day').format()),
    _useState10 = _slicedToArray(_useState1, 2),
    to = _useState10[0],
    setTo = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    dataChanged = _useState12[0],
    setDataChanged = _useState12[1];
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataLoading = _useState14[0],
    setIsDataLoading = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    deptRevenue = _useState16[0],
    setDeptRevenue = _useState16[1];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getdailycash/' + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(false);
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
      if (response[1].data.status == 200) {
        setTotalCash(response[1].data.totalCash);
        setTotalAmount(response[1].data.totalAmount);
        setPostPaidAmount(response[1].data.totalPostPaid);
        var nr = [];
        var ar1 = response[1].data.deptRevenue.filter(function (d) {
          return d.label == "CON";
        });
        var ar2 = response[1].data.deptRevenue.filter(function (d) {
          return d.label != "CON";
        });
        var totalCons = 0;
        ar1.forEach(function (ar) {
          totalCons += ar.revenue;
        });
        var cr = [{
          label: "CON",
          revenue: totalCons
        }];
        nr = cr.concat(ar2);
        setDeptRevenue(nr);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    });
  }, [dataChanged, from, to]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      ref: ref,
      id: "printable",
      style: {
        padding: "38px"
      },
      children: [/*#__PURE__*/_jsx(DocumentHeader, {
        title: "RAPPORT DE CAISSE"
      }), /*#__PURE__*/_jsx(ARow, {
        children: /*#__PURE__*/_jsx(ACol, {
          style: {
            fontWeight: "bold"
          },
          children: /*#__PURE__*/_jsx(Moment, {
            date: from,
            format: "DD/MM/YYYY"
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(ARow, {
        children: [/*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFF2ED",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Total ce jour",
              value: totalAmount
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFFFF0",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Cash ce jour",
              value: totalCash
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFF0FE",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Convention\xE9 ce jour",
              value: postPaidAmount
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(ARow, {
        children: [/*#__PURE__*/_jsx(ACol, {
          span: 6,
          children: deptRevenue.length > 0 && /*#__PURE__*/_jsx(Table, {
            size: "xs",
            responsive: true,
            children: deptRevenue.map(function (dr) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: dr.label
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: dr.revenue.toLocaleString("Fr")
                })]
              }, dr.id);
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          span: 18,
          children: /*#__PURE__*/_jsx(CashierTransactionsList, {
            dataChanged: dataChanged
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
        children: Common.currentUser.firstname + " " + Common.currentUser.lastname
      })]
    })
  });
});
export default CashierReport;